import Cookies from 'js-cookie'

/*
 * token在Cookie中存储的时间，单位为天，（js-cookie支持传传入时长/天，或者过期时间）
 */
export const cookieExpires = 1  // 同后端token过期时间

/**
 * 描述 设置cookie
 * @date 2020-04-10
 * @param {any} key:string
 * @param {any} value:any
 * @param {any} expiresTime:any 过期时间，不传默认读取配置
 * @returns {any}
 */
export const setCookie = (key, value, expiresTime) => {
  Cookies.set(key, value, { expires: expiresTime || cookieExpires })
}
/**
 * 描述 获取cookie
 * @date 2020-04-10
 * @param {any} key:string
 * @returns {any}
 */
export const getCookie = (key) => {
  const val = Cookies.get(key)
  if (val === undefined || val === null) {
    return ''
  } else {
    return val
  }
}
/**
 * 描述 移除cookie
 * @date 2020-04-10
 * @param {any} key:string
 * @returns {any}
 */
export const removeCookie = (key) => {
  return Cookies.remove(key)
}
